angular.module('common.directives.omStatCounter', [])

    .directive('omStatCounter', function ($window) {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/omStatCounter/omStatCounter.html',
            scope: {
                value: '@'
            }, 
            controller: 'OmStatCounterController',
            link: {
                pre: function preLink(scope, element, attrs, ctrl) {
                    //use this when necessary to force the counter to spin even if the odometer control receives non zero value right from the very beginning
                    //scope.value = 0;

                    //Init the odometer control
                    var odo = new Odometer({
                        el: element[0],
                        value: scope.value,
                        format: 'd',
                        duration: 200,
                        theme: 'default',
                        hideLeadingZeros: true
                    });
                },
                post: function postLink(scope, element, attrs, ctrl) {
                    var odoWatcherDestructor;
                    var containerElem = element[0];

                    scope.showOdometer = scope.value !== '';

                    //init watcher
                    odoWatcherDestructor = scope.$watch('value', function (newVal, oldVal) {
                        scope.showOdometer = newVal !== '';

                        containerElem.innerHTML = newVal;
                    });

                    scope.$on("$destroy", function () {
                        if (odoWatcherDestructor) {
                            odoWatcherDestructor();
                        }
                    });
                }
            }
        };
    })

    .controller('OmStatCounterController', function ($scope, $element, $timeout) {
        
        init();

        function init() {

            
        }
    })
;
